const parseRecallActivities = (recallActivities) => {
  let NumberOfActive = 0
  let NumberOfPending = 0
  let NumberOfCompleted = 0
  let NumberOfAll = 0

  // 'ACTIVE' | 'PENDING' | 'COMPLETED'
  // We have the same thing in RecallDocument
  if (recallActivities) {
    recallActivities.forEach(recall => {
      let status = recall.vehicleStatus && recall.vehicleStatus.toUpperCase()
      if (status !== "ACTIVE" && status !== "PENDING") {
        status = "COMPLETED"
      }

      if (status === "ACTIVE") {
        NumberOfActive += 1
        NumberOfAll += 1
      }
      if (status === "PENDING") {
        NumberOfPending += 1
        NumberOfAll += 1
      }
      if (status === "COMPLETED") {
        NumberOfCompleted += 1
      }
    })
  }

  let Status = ""
  if (NumberOfAll > 0) {
    Status = `YOUR VEHICLE IS AFFECTED BY ${NumberOfAll} RECALL${NumberOfAll > 1 ? "s" : ""}`
  } else {
    Status = "NO OUTSTANDING RECALLS"
  }

  return {
    NumberOfActive,
    NumberOfPending,
    NumberOfCompleted,
    NumberOfAll,
    Status
  }
}

export default parseRecallActivities



// WEBPACK FOOTER //
// ./src/AtomicUtils/parseRecallActivities.js